import { HttpErrorResponse, HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { catchError, retry, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/enviroment';



export const authInterceptor:HttpInterceptorFn = (req, next) => {
  const authToken = localStorage.getItem('token');
  const authRequest = req.clone({
    headers: req.headers
    .set('Authorization', `Bearer ${authToken}`)
    .set('X-API-KEY',environment.apiKey)
    .set('Content-Type','application/json')
  });
  return next(authRequest);
};

export const loggingInterceptorFunctional: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(tap(event => {
    if (event.type === HttpEventType.Response) {
      if( event.status === 401) {
        console.log('unauthorized',event.status);

      }else if(event.status ===500){
        console.log('server error',event.status);
      }
      
    }
  }));
}


// Loading Spinner Interceptor
// export const loadingSpinnerInterceptorFunctional: HttpInterceptorFn = (req, next) => {
//   const loadingService = new LoadingService(); // Instantiate the loading service
//   loadingService.showLoadingSpinner(); // Show loading spinner UI element

//   return next(req).pipe(
//     finalize(() => {
//       loadingService.hideLoadingSpinner(); // Hide loading spinner UI element
//     })
//   );
// };


export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  const maxRetries = 3;

  return next(req).pipe(
    retry(maxRetries),
    catchError((error: HttpErrorResponse) => {
      console.error('Retry Error:', error);
      return throwError(()=> error);
    })
  );
};